export default "__VITE_ASSET__KLsGi$Wy__"